// components
import LanguageSwitcher from "../Components/LanguageSwitcher/LanguageSwitcher"
const LanguageSwitcherPage = () => {
    return (
        <LanguageSwitcher />
    )
}
export default LanguageSwitcherPage;